/* eslint-disable */
import { useState, useRef } from 'react';
import { HeaderPage, Button, SelectorTipoDescarga } from 'components';
import { message, Col } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { CASAS, MONITOREOS_VISITAS_VERIFICACION } from 'constants/tipoMonitoreos';
import { getMonitoreosCasas, validarHallazgosByMoni } from 'actions/monitoreos.actions';
import * as MensGrales from 'constants/MensajesGenerales';
import { TablaMonitoreo } from './components/TablaMonitoreo';
import { BuscadorMonitoreo } from './components/BuscadorMonitoreo';
import './MonitoreosCasas.scss';
import pdf from '../../../assets/Documents/GuiasUsuario/07_Material_Cap_Visitas_de_validacion_a_casas_de_apoyo_ciudadano_campana_y_precampana_web.pdf';

const nameFile = 'Guía_de_usuario_Visitas_de_verificación_a_casas_web.pdf';

// MNI - Genera formatos PDF al validar
import { generarPDFMonitoreosValidacion } from 'services/monitoreos.service';

const MonitoreosCasas = () => {
  const [mainFilters, setMainFilters] = useState({});
  const seleccion = useRef({});
  const seleccionValidacion = useRef({});
  const [messageApi, contextHolder] = message.useMessage();

  const [procesarTodo, setProcesarTodo] = useState(false);

  const dispatch = useDispatch();

  const showTotal = (total, range) => {
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };

  const [pagination, setPagination] = useState({
      position: ['bottomRight'],
      showQuickJumper: true,
      size: 'small',
      pageSize: 10,
      current: 1,
      showTotal,
      total: 0,
      showSizeChanger: false
    });

  const getMonitoreosSeleccionados = () => {
    const monitoreos = [];
    Object.entries(seleccionValidacion.current).forEach(([key, value]) => {
      if (value) {
        monitoreos.push(Number(key));
      }
    });
    return monitoreos;
  };
  const handleValidateMonitoring = async () => 
  {
    // console.log('validating', seleccionValidacion);
    const monitoreosSeleccionados = getMonitoreosSeleccionados();
    if (monitoreosSeleccionados.length === 0) {
      message.error('Debes seleccionar al menos un monitoreo para validar.');
      return;
    }
    const request = {
      monitoreos: {
        toDeValidate: [],
        toValidate: []
      }
    };
    for (let j = 0; j < monitoreosSeleccionados.length; j += 1) {
      request.monitoreos.toValidate.push({
        pkMonitoreo: monitoreosSeleccionados[j],
        idMonitoreo: monitoreosSeleccionados[j]
      });
    }
    // console.log('request', request);
    const { success, response } = await dispatch(validarHallazgosByMoni(request));
    if (success && response?.data.code === 200) 
    {
      for (let i = 0; i < monitoreosSeleccionados.length; i++) 
      {
        // MNI - Llamado a la generación de PDF's al momento de validar 
        let monitoreoPDF = [{
            idMonitoreo     : monitoreosSeleccionados[i]
          , idTipoMonitoreo : 4             
          , tiposActa       : [{ "id": 7 }] // Visitas casas
        }];
        // Se genera PDF una vez que se han almacenado las Muestras
        let generoPDF = await generarPDFMonitoreosValidacion(monitoreoPDF);
        if(generoPDF)
        {
          console.log('Se generó correctamente el PDF');
        }else{
          console.log('Error al generar el PDF');
        } 
      }

      message.success('Los monitoreos se validaron correctamente');
      dispatch(getMonitoreosCasas(pagination.current, pagination.pageSize));
    } else if (response?.causa !== undefined) {
      messageApi.error(response.causa);
    } else {
      messageApi.error(MensGrales.MAV1_2);
    }
  };

  const handleDownloadGuia = (documentName) => {
    try {
      if (documentName !== null) {
        const docuName = documentName;
        const link = document.createElement('a');
        link.href = docuName;
        link.download = nameFile;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      messageApi.error(MensGrales.ERROR_GET_GUIA_USUARIO_PDF);
    }
  };

  const handleProcesarTodoChange = (valor) => 
  {
    try 
    {
      setProcesarTodo(valor);
    } catch (error) 
    {
      console.log('Error: ', error); 
    }
  };

  return (
    <div className="casasMonitoreo-container">
      <div className="header-page-casas">
        <Col span={18}>
          <HeaderPage
            section="Visitas de verificación"
            title="Casas de Precampaña o Campaña"
            header="Selecciona al menos un campo para realizar la búsqueda."
          />
        </Col>
        <Button
          text="Descarga la guía"
          icon={<FilePdfOutlined />}
          onClick={() => handleDownloadGuia(pdf)}
        />
      </div>
      <BuscadorMonitoreo onSearch={setMainFilters} />
      {contextHolder}
      <TablaMonitoreo
        mainFilters={mainFilters}
        seleccion={seleccion}
        seleccionValidacion={seleccionValidacion}
        handleValidateMonitoring={handleValidateMonitoring}
        pagination={pagination}
        setPagination={setPagination}
        onProcesarTodoChange = { handleProcesarTodoChange }
      />
      <SelectorTipoDescarga
        seleccion={seleccion}
        tipoMonitoreo={MONITOREOS_VISITAS_VERIFICACION}
        tipoActa={CASAS}
        procesarTodo = { procesarTodo }
      />
    </div>
  );
};

export default MonitoreosCasas;
